<template>
  <div class="create_order_page">
    <div class="page_header">
      <div class="site_title">喜乐 {{ data.site_name }}</div>
      <div class="site_no">No.{{ data.id }}</div>
    </div>

    <div class="form_container">
      <!-- Info Section -->
      <div class="info_section card">
        <div class="info_row" v-if="data.site_type == 1">
          <span class="label">今日油价</span>
          <div class="price_tag">
            <span>0# <small>￥</small>{{ data.price }}</span>
            <span v-if="data.oil_type=='B5#'">B5# <small>￥</small>{{ data.price_b5 }}</span>
          </div>
        </div>
        <div class="info_row" v-if="data.site_type == 1">
          <span class="label">账户余额</span>
          <span class="value balance">￥{{ money }}</span>
        </div>
        <div class="info_row" v-if="data.site_type == 1">
          <span class="label">可加油量</span>
          <div class="value">
            <span>0# {{ (money / data.price).toFixed(2) }}升</span>
            <span v-if="data.oil_type=='B5#'">B5# {{ (money / data.price_b5).toFixed(2) }}升</span>
          </div>
        </div>
        <div class="info_row" v-if="data.site_type == 2">
          <span class="label">账户油量</span>
          <span class="value highlight">{{ account_oil }}升</span>
        </div>
      </div>

      <!-- Input Section -->
      <div class="input_section card">
        <div class="input_group">
          <span class="label">加油品种</span>
          <span class="static_value">0# 柴油</span>
        </div>

        <div class="input_group">
          <div class="select_wrapper">
            <select @change="getCouponSelected" v-model="couponSelected" class="custom_select">
              <option v-for="coupon in couponList" :value="coupon.id" :key="coupon.id">{{ coupon.name }}</option>
            </select>
            <div class="select_display">
              <span class="label">{{ couponSelected }}</span>
              <span class="iconfont icon-xiangyou-copy"></span>
            </div>
          </div>
          
          <div class="editor_input" v-show="couponSelected=='加油油量'">
            <input v-model="total_number" type="number" placeholder="请输入升数" @input="change">
            <span class="unit">升</span>
          </div>
          <div class="editor_input" v-show="couponSelected=='加油金额'">
            <input v-model="total_money" type="number" placeholder="请输入金额">
            <span class="unit">元</span>
          </div>
        </div>

        <div class="input_group">
          <div class="select_wrapper">
            <select class="custom_select" v-model="car_num">
              <option v-for="coupon in car_arr" :value="coupon" :key="coupon">{{ coupon }}</option>
            </select>
            <div class="select_display">
              <span class="label">车牌号</span>
              <div class="car_selector">
                <span class="car_num_val">{{ car_num }}</span>
                <span class="iconfont icon-xiangyou-copy"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Payment Section -->
      <div class="payment_section card" v-show="selecPayType_show">
        <div class="section_subtitle">选择支付方式</div>
        <div class="pay_options">
          <mt-radio v-model="pay_type" :options="options"></mt-radio>
        </div>
      </div>
    </div>

    <div class="submit_area">
      <div class="submit_btn" :class="{ 'busy': Submit_true }" @click="submit">
        {{ Submit_true ? '处理中...' : '提交订单' }}
      </div>
    </div>

    <!-- Alert Modals -->
    <div v-show="failure_show" class="modal_overlay">
      <div class="modal_content error">
        <div class="modal_icon"><span class="iconfont icon-cuo"></span></div>
        <div class="modal_title">提交失败</div>
        <div class="modal_msg">{{ failure_text }}</div>
        <div class="modal_btn" @click="failures">确认</div>
      </div>
    </div>

    <div v-show="noMatching_show" class="modal_overlay">
      <div class="modal_content warning">
        <div class="modal_icon">!</div>
        <div class="modal_msg">{{ noMatching_text }}</div>
        <div class="modal_btn" @click="nocarBt">知道了</div>
      </div>
    </div>

    <div v-show="nocar_num_show" class="modal_overlay">
      <div class="modal_content warning">
        <div class="modal_icon">!</div>
        <div class="modal_msg">车牌未绑定，请联系车队进行绑定操作</div>
        <div class="modal_btn" @click="nocarBt">确认</div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "../common";
import wx from "weixin-js-sdk";
import {Radio, Indicator, MessageBox} from 'mint-ui';
import Vue from "vue";
import querystring from "querystring";

Vue.component(Radio.name, Radio);
export default {
  name: 'createOrder',
  data() {
    return {
      data: {
        site_name: "",
        id: "",
        oilman_id: ""//油站id
      },
      car_num: "",
      batch: "",//批号,扫描app二维码要用到
      total_number: "",//数量
      money: "",//金额
      total_money: "",//金额
      token: "",
      car_arr: [],//存放司机车牌号的数组
      pay_type: "账户余额支付",
      options: [
        {
          label: '账户余额支付',
          value: '账户余额支付',
        },
        {
          label: '微信支付',
          value: '微信支付'
        },
        {
          label: '支付宝支付',
          value: '支付宝支付'
        }
      ],
      couponList: [
        {
          id: '加油油量',
          name: "加油油量"
        },
        {
          id: "加油金额",
          name: "加油金额"
        }
      ],
      couponSelected: "加油油量",
      Submit_true: false,//提交了就为true,避免重复提交
      selecPayType_show: false,//选择支付方式默认不显示
      failure_text: "",
      failure_show: false,
      noMatching_text: "",
      noMatching_show: false,
      account_oil: "",//账户油量
      mobile: "",
      nocar_num_show: false,
      appXm: {
        app_id: '',
        oilNumber: '',//最大可用加油升数
        oilName: '',//油品名称
        userPhone: '',//手机号
        truckNo: '',//车牌
        accountType: '',//账号类型
        uscCode: '',//车队信用代码
      },
    }
  },
  methods: {
    change(e) {
      if (e.target.value >= 1000) {
        common.toast("加油油量不能大于1000");
        e.target.value = '';
      }
    },
    nocarBt() {
      this.$router.push({name: 'index'});
    },
    submit() {
      if (this.Submit_true) {
        return;
      }
      //Indicator.open();
      this.Submit_true = true;
      wx.getLocation({
        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: res => {
          let querystring = require('querystring');
          this.$api.post('wx/User/getLocation',
              querystring.stringify({
                latitude: res.latitude,
                longitude: res.longitude,
                token: this.token,
                action: "create_order",
              })
          )
        }
      });
      let querystring = require('querystring');
      if (this.appXm.app_id == 'xiangmeng') {
        if (eval(this.total_number) > eval(this.appXm.oilNumber)) {
          this.Submit_true = false;
          //common.toast("加油油量大于最大可用加油量");
          MessageBox('错误', '加油油量大于最大可用加油量！');
          return;
        }
        this.$api.post('wx/putbox/createOrder',
            querystring.stringify({
              site_id: this.data.id,
              app_id: this.appXm.app_id,
              oilNumber: this.appXm.oilNumber,
              oilName: this.oilname,
              userPhone: this.appXm.userPhone,
              truckNo: this.appXm.truckNo,
              accountType: this.appXm.accountType,
              uscCode: this.appXm.uscCode,
              total_number: this.total_number,
            })
        ).then(data => {
          if (data.data.status == 1) {
            let order_id = data.data.data.id;
            this.$router.replace({path: '/orderDetail/' + order_id + '?app_id=xiangmeng'});
          } else {
            common.toast(data.data.msg);
            this.Submit_true = false;
          }
        })
        return;
      }

      this.$api.post('wx/User/payOrder',
          querystring.stringify({
            site_id: this.data.id,
            car_number: this.car_num,
            oil_name: "0#",
            total_number: this.total_number,
            token: this.token,
            batch: this.batch,
            latitude: this.latitude,
            longitude: this.longitude,
          })
      ).then(data => {
        if (data.data.status == 1) {
          let order_id = data.data.data.order_id;
          this.$router.replace({path: '/orderDetail/' + order_id});
        } else {
          Indicator.close();
          this.failure_show = true;
          this.failure_text = data.data.msg;
        }
      }).catch(err => {
        console.log(err);
      })
    },
    //当选择加油金额时,显示选择支付方式;
    getCouponSelected() {
      if (this.couponSelected == "加油金额") {
        this.selecPayType_show = true;
      } else {
        this.selecPayType_show = false;
      }
    },
    failures() {
      this.$router.replace("/");
    },
    //验证是否为合作加油点
    VerifyDriver(site_id) {
      let token = this.token;
      let mobile = this.mobile;
      let querystring = require('querystring');
      this.$api.post('wx/checkAccount',
          querystring.stringify({
            token,
            site_id,
            mobile
          })
      ).then(data => {
        if (data.data.status == 0) {
          this.noMatching_show = true;
          this.noMatching_text = data.data.msg;
        } else {
          this.noMatching_show = false;
        }
      }).catch((err) => {
        common.toast(err);
      })
    },
    //获取账户存油和车牌号
    GetCarNumAndAccounOil(oilman_id) {
      let querystring = require('querystring');
      this.$api.post("wx/index",
          querystring.stringify({
            token: this.token,
          })
      ).then(data => {
        if (data.data.status == 1) {
          let car_Obj = data.data.data.car_list;
          let account_list = data.data.data.account_list;
          //获取司机车牌号(可能有多个)
          if (data.data.data.car_number) {
            this.car_num = data.data.data.car_number;
          } else {
            this.nocar_num_show = true;
          }
          for (var index in car_Obj) {
            this.car_arr.push(car_Obj[index]);
          }
          //获取该加油点账户油量
          for (var index in account_list) {
            if (account_list[index].oilman_id == oilman_id || account_list[index].parent_name == oilman_id) {
              this.account_oil = account_list[index].oil_store;
              this.money = account_list[index].money;
            }
            if (this.account_oil == "" && account_list[index].oilman_id == -1) {
              this.account_oil = account_list[index].oil_store;
              this.money = account_list[index].money;
            }
          }
        } else {
          this.$router.replace({name: 'login'});
        }
      })
    },
    //获取司机及油站信息;
    getData() {
      let uid = this.$router.currentRoute.params.id;
      let querystring = require('querystring');
      this.VerifyDriver(uid);
      this.$api.post('/wx/site',
          querystring.stringify({
            token: this.token,
            uid: uid
          })
      ).then(data => {
        if (!!data.data.data[0]) {
          this.data = data.data.data[0];
          let oilman_id = data.data.data[0].oilman_id;
          this.GetCarNumAndAccounOil(oilman_id);
        }
      })
    },
    getSite() {
      let uid = this.$router.currentRoute.params.id;
      let querystring = require('querystring');
      this.$api.post('/wx/site',
          querystring.stringify({
            token: this.token,
            uid: uid
          })
      ).then(data => {
        if (!!data.data.data[0]) {
          this.data.site_name = data.data.data[0].site_name
          this.data.id = data.data.data[0].id
          if (data.data.data[0].oil_type == 'B5#') {
            this.oilname_arr = ['0#', 'B5#'];
          }
        }
      })
    },
    //获取用户openid
    getOpenid() {
      let url = window.location.href;
      let querystring = require('querystring');
      this.$api.post('/wx/getUrl',
          querystring.stringify({
            url
          })
      ).then(({data}) => {
        window.location.href = data;
      })
    },
    getUuid(uuid) {
      let querystring = require('querystring');
      this.$api.post('/wx/uuid/login',
          querystring.stringify({
            uuid: uuid
          })
      ).then(({data}) => {
        if (data.status == 1) {
          common.setlocalStorage("userInfo", JSON.stringify(data.data));
        } else {
          this.$router.push({name: 'login'})
        }
      });
    },
    //查询用户是否绑定手机号;
    ifQueryBinding(openid) {
      let querystring = require('querystring');
      this.$api.post('/wx/checkOpenid',
          querystring.stringify({
            openid
          })
      ).then(({data}) => {
        if (data.status == 1) {
          //绑定了手机号,获取用户信息
          common.setCookie("token", data.data.token, 365);
          common.setCookie("mobile", data.data.mobile, 365);
          this.login_bol = true;
          this.mobile = data.data.mobile;
          this.token = data.data.token;
          this.getData();
        } else {
          //没有绑定了手机号,去登录页绑定
          this.$router.push({
            name: 'login',
            query: {
              openid: openid
            }
          })
        }
      })
    },
  },
  mounted() {
    //如果有批号就获取批号
    this.batch = this.$router.currentRoute.query.batch;
    //判断cookie中是否存在token
    let ifcookietoken = document.cookie.indexOf("token=") != -1;
    //判断地址栏上是否存在openid;
    let ifopenid = window.location.href.indexOf("openid") != -1;

    //驮鸟uuid登录
    let uuid = this.$route.query.uuid;
    if (uuid) {
      this.getUuid(uuid);
    }

    this.appXm.app_id = this.$router.currentRoute.query.app_id;//平台标识

    if (this.appXm.app_id == 'xiangmeng') {
      this.appXm.oilNumber = this.$router.currentRoute.query.oilNumber;//最大可用加油升数
      this.appXm.oilName = this.$router.currentRoute.query.oilName;//油品名称
      this.appXm.userPhone = this.$router.currentRoute.query.userPhone;//手机号
      this.appXm.truckNo = this.$router.currentRoute.query.truckNo;//车牌
      this.appXm.accountType = this.$router.currentRoute.query.accountType;//账号类型
      this.appXm.uscCode = this.$router.currentRoute.query.uscCode;//车队信用代码
      this.car_num = this.appXm.truckNo;
      this.account_oil = this.appXm.oilNumber;
      this.getSite();
      return;
    }

    //判断是否已经登录
    if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
      this.mobile = JSON.parse(common.getlocalStorage("userInfo")).mobile;
      this.token = JSON.parse(common.getlocalStorage("userInfo")).token;
      this.getData();
    } else if (ifcookietoken) {
      this.token = common.getCookie("token");
      this.mobile = common.getCookie("mobile");
      this.getData();
    } else if (ifopenid) {
      let openid = window.location.href.split("openid=")[1].split("#/")[0];
      this.ifQueryBinding(openid);
    } else {
      this.$router.replace({name: 'login'});
      //this.getOpenid();
    }
  },
  destroyed() {
    Indicator.close();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.create_order_page {
  width: 100vw;
  min-height: 100vh;
  background-color: #f6f8fa;
  display: flex;
  flex-direction: column;
}

.page_header {
  background: linear-gradient(135deg, #106EBE 0%, #005a9e 100%);
  padding: 30px 20px 60px;
  color: white;
  text-align: center;
}

.site_title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 4px;
}

.site_no {
  font-size: 13px;
  opacity: 0.8;
}

.form_container {
  padding: 0 20px;
  margin-top: -30px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
}

.info_section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info_row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-size: 14px;
}

.info_row .label {
  color: #adb5bd;
  font-weight: 500;
}

.info_row .value {
  color: #495057;
  font-weight: 600;
  text-align: right;
  display: flex;
  flex-direction: column;
}

.price_tag {
  display: flex;
  flex-direction: column;
  text-align: right;
  color: #e03131;
  font-weight: 700;
}

.price_tag small {
  font-size: 10px;
}

.balance {
  color: #106EBE;
}

.highlight {
  color: #106EBE;
}

.input_section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.input_group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.input_group .label {
  font-size: 13px;
  color: #adb5bd;
  font-weight: 600;
}

.static_value {
  font-size: 16px;
  font-weight: 700;
  color: #333;
}

.select_wrapper {
  position: relative;
  width: 100%;
}

.custom_select {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 2;
}

.select_display {
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid transparent;
}

.car_selector {
  display: flex;
  align-items: center;
  gap: 10px;
}

.car_num_val {
  background: #106EBE;
  color: white;
  padding: 2px 10px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 14px;
}

.editor_input {
  display: flex;
  align-items: center;
  background: #f8f9fa;
  border-radius: 12px;
  padding: 0 16px;
  height: 50px;
  border: 1px solid #106EBE;
}

.editor_input input {
  flex: 1;
  border: none;
  background: transparent;
  font-size: 20px;
  font-weight: 700;
  color: #106EBE;
  outline: none;
  text-align: center;
}

.editor_input .unit {
  font-size: 14px;
  color: #adb5bd;
  font-weight: 600;
}

.section_subtitle {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  margin-bottom: 12px;
}

.submit_area {
  padding: 40px 20px;
  margin-top: auto;
}

.submit_btn {
  width: 100%;
  height: 54px;
  background: linear-gradient(135deg, #106EBE 0%, #005a9e 100%);
  color: white;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  box-shadow: 0 8px 20px rgba(16, 110, 190, 0.2);
}

.submit_btn.busy {
  opacity: 0.7;
}

/* Modals */
.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.6);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.modal_content {
  background: white;
  border-radius: 20px;
  width: 100%;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.modal_icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  font-size: 30px;
  font-weight: 700;
}

.modal_content.error .modal_icon {
  background: #fff5f5;
  color: #fa5252;
}

.modal_content.warning .modal_icon {
  background: #fff9db;
  color: #fcc419;
}

.modal_title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
}

.modal_msg {
  font-size: 14px;
  color: #495057;
  margin-bottom: 24px;
  line-height: 1.5;
}

.modal_btn {
  width: 100%;
  height: 44px;
  background: #f1f3f5;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #495057;
}

.modal_content.error .modal_btn {
  background: #fa5252;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/createOrder.vue